<template>
	<v-card tile elevation="0" class="arp-aba-informacoes">
		<v-card-text>
			<v-form v-model="isFormValid" ref="formAdicionarNotificacao" lazy-validation>
				<v-row>
					<v-col cols="12" sm="4">
						<label-personalizado nome-campo="Fornecedor" obrigatorio-por-padrao></label-personalizado>
						<v-autocomplete
							v-model="fornecedor"
							:items="fornecedoresDataSource"
							:rules="fornecedorRules"
							placeholder="Selecione"
							class="ma-0 py-0 pt-3 mt-1"
							item-value="idPessoa"
							item-text="nomeFornecedor"
							dense
							clearable
							:disabled="isDesabilitarCampoFornecedor || modoVisualizacao"
						>
						</v-autocomplete>
					</v-col>
					<v-col cols="12" sm="4">
						<label-personalizado nome-campo="Infração" obrigatorio-por-padrao></label-personalizado>
						<v-autocomplete
							v-model="tipoInfracaoSelecionada"
							:items="tipoInfracaoDataSource"
							:rules="tipoRules"
							placeholder="Selecione"
							class="ma-0 py-0 pt-3 mt-1"
							item-value="id"
							item-text="nome"
							dense
							clearable
							:disabled="modoVisualizacao"
						>
							<template #item="data">
								<texto-tooltip :tamanho-maximo="40" :texto="data.item.nome"></texto-tooltip>
							</template>
						</v-autocomplete>
					</v-col>
					<v-col cols="12" sm="4">
						<label-personalizado nome-campo="Órgão" obrigatorio-por-padrao></label-personalizado>
						<v-autocomplete
							v-model="orgaoSelecionado"
							:items="orgaoDataSource"
							:rules="orgaoSancionadorRules"
							placeholder="Selecione"
							class="ma-0 py-0 pt-3 mt-1"
							item-value="id"
							item-text="sigla"
							dense
							clearable
							:disabled="!fornecedorSelecionado || modoVisualizacao"
						>
						</v-autocomplete>
					</v-col>
				</v-row>

				<v-row>
					<v-col cols="12">
						<label-personalizado nome-campo="Descrição"></label-personalizado>
						<v-textarea
							ref="modal-penalidade-motivo"
							v-model.trim="descricao"
							:rules="descricaoRules"
							counter="300"
							placeholder="Informe"
							rows="3"
							:disabled="modoVisualizacao"
						></v-textarea>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
	</v-card>
</template>

<script>
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import { actionTypes, mutationTypes } from '@/core/constants'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import { mapState } from 'vuex'
import TextoTooltip from '@/views/components/TextoTooltip.vue'

export default {
	name: 'penalidade-aba-notificacoes',
	components: { TextoTooltip, LabelPersonalizado },
	mixins: [validacaoFormulario],
	props: {
		idEntidade: {
			type: [String, Number],
			required: true,
		},
		idAta: {
			type: [String, Number],
			required: true,
		},
		entidadeTipo: {
			type: Object,
			required: true,
		},
		modoVisualizacao: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isFormValid: false,
			fornecedorRules: [(v) => this.regraObrigatoriedade(v, 'Fornecedor é obrigatório.')],
			tipoRules: [(v) => this.regraObrigatoriedade(v, 'Tipo infração é obrigatório.')],
			orgaoSancionadorRules: [(v) => this.regraObrigatoriedade(v, 'Orgão é obrigatório.')],
			descricaoRules: [
				(v) => v.length <= 300 || 'O campo descrição deve ser igual ou menor do que 300 caracteres.',
			],
			fornecedorSelecionado: null,
			fornecedoresDataSource: [],
			tipoInfracaoSelecionada: null,
			tipoInfracaoDataSource: [],
			orgaoSelecionado: null,
			orgaoDataSource: [],
			isDesabilitarCampoFornecedor: false,
			tipoEntidade: 'INFRACAO',
			descricao: '',
		}
	},
	computed: {
		...mapState({
			orgaoSancionadorSalvo: (state) => state.penalidades.orgaoSancionadorSalvo,
			idPenalidadeSalva: (state) => state.penalidades.idPenalidadeSalva,
			abaSelecionada: (state) => state.penalidades.abaSelecionada,
			inserirNotificacaoPenalidade: (state) => state.penalidades.inserirNotificacaoPenalidade,
		}),
		fornecedor: {
			get() {
				return this.fornecedorSelecionado
			},
			set(value) {
				this.fornecedorSelecionado = value
				if (this.fornecedorSelecionado) this.buscarOrgaosSancionadores()
				this.orgaoSelecionado = null
			},
		},
	},
	watch: {
		abaSelecionada: {
			async handler() {
				if (this.abaSelecionada !== 0) return
				if (this.$refs.formAdicionarNotificacao) this.resetarVariaveis()
				await this.buscarInformacoes()
			},
			immediate: true,
		},
		orgaoSelecionado() {
			if (!this.orgaoSancionadorSalvo) return

			const habilitarAbaItens = this.orgaoSelecionado === this.orgaoSancionadorSalvo
			this.habilitarOuDesabilitarAbaItens(habilitarAbaItens)
		},
		async inserirNotificacaoPenalidade() {
			await this.inserirNotificacao()
		},
	},
	methods: {
		async buscarFornecedoresPenalidade() {
			const { fornecedores } = await this.$store.dispatch(
				actionTypes.PENALIDADES.BUSCAR_FORNECEDORES_PENALIDADE,
				{ idAta: this.idAta, ...this.montarObjCommon() },
			)
			this.fornecedoresDataSource = fornecedores

			if (fornecedores.length === 1) {
				this.fornecedorSelecionado = fornecedores.at(0).idPessoa
				await this.buscarOrgaosSancionadores()
			}
		},
		async buscarTiposPenalidades() {
			const { itens } = await this.$store.dispatch(actionTypes.PENALIDADES.BUSCAR_TIPOS_PENALIDADE, {
				tipoPenalidade: this.tipoEntidade,
				...this.montarObjCommon(),
			})
			this.tipoInfracaoDataSource = itens
		},
		async buscarOrgaosSancionadores() {
			const { orgaosSancionadores } = await this.$store.dispatch(
				actionTypes.PENALIDADES.BUSCAR_ORGAOS_SANCIONADORES_PENALIDADE,
				{
					idAta: this.idAta,
					idPessoa: this.fornecedorSelecionado,
					...this.montarObjCommon(),
				},
			)
			this.orgaoDataSource = orgaosSancionadores
			if (orgaosSancionadores.length === 1) this.orgaoSelecionado = orgaosSancionadores.at(0).id
		},
		async buscarDadosGeraisPenalidade() {
			if (!this.idPenalidadeSalva) return

			const dados = await this.$store.dispatch(actionTypes.PENALIDADES.BUSCAR_DADOS_GERAIS_PENALIDADE, {
				...this.montarObjCommon(),
				idPenalidade: this.idPenalidadeSalva,
			})

			const { unidadeOrganizacionalOutput, fornecedorOutput, isEfetivada } = dados
			this.setarValoresNasVariaveisDeControle(
				unidadeOrganizacionalOutput.id,
				fornecedorOutput.idPessoa,
				isEfetivada,
			)
		},
		setarValoresNasVariaveisDeControle(orgao, fornecedor, isEfetivada) {
			this.$store.commit(mutationTypes.PENALIDADES.SET_ORGAO_SANCIONADOR_SALVO, orgao)
			this.$store.commit(mutationTypes.PENALIDADES.SET_FORNECEDOR_SALVO, fornecedor)
			this.habilitarAbas([1, 2, 3])
			if (isEfetivada) this.$store.commit(mutationTypes.PENALIDADES.SET_IS_PENALIDADE_EFETIVADA)
			this.isDesabilitarCampoFornecedor = true
			this.fornecedor = fornecedor
			this.orgaoSelecionado = orgao
		},
		async buscarInformacoes() {
			await Promise.all([
				await this.buscarDadosGeraisPenalidade(),
				await this.buscarFornecedoresPenalidade(),
				await this.buscarTiposPenalidades(),
			])
		},
		async inserirNotificacao() {
			if (this.$refs.formAdicionarNotificacao.validate()) {
				await this.$store
					.dispatch(
						actionTypes.PENALIDADES.NOTIFICACOES.INSERIR_NOTIFICACAO_PENALIDADE,
						this.montarObjNotificacao(),
					)
					.then((resposta) => {
						this.mostrarNotificacaoSucesso("Notificação inserida com sucesso, a lista de notificações está visível em Documentos.")
						this.$store.commit(mutationTypes.PENALIDADES.SET_ID_PENALIDADE_SALVA, resposta.idPenalidade)
						this.limparCampos()
						this.setarValoresNasVariaveisDeControle(
							this.orgaoSelecionado,
							this.fornecedorSelecionado,
							false,
						)
						this.$store.commit(mutationTypes.PENALIDADES.SET_ABA_SELECIONADA, 2)
					})
			}
		},
		limparCampos() {
			this.$refs.formAdicionarNotificacao.resetValidation()
			this.tipoInfracaoSelecionada = null
			this.descricao = ''
		},
		habilitarOuDesabilitarAbaItens(habilitar) {
			const [abaItens] = [1]
			this.$store.commit(mutationTypes.PENALIDADES.SET_VISIBILIDADE_ABA, { aba: abaItens, habilitar })
		},
		habilitarAbas(abas) {
			abas.forEach((aba) => {
				this.$store.commit(mutationTypes.PENALIDADES.SET_VISIBILIDADE_ABA, { aba, habilitar: true })
			})
		},
		montarObjNotificacao() {
			return {
				idPenalidade: this.idPenalidadeSalva,
				idEntidade: this.idEntidade,
				tipo: this.entidadeTipo,
				fornecedor: this.fornecedorSelecionado,
				tipoInfracao: this.tipoInfracaoSelecionada,
				idOrgao: this.orgaoSelecionado,
				descricao: this.descricao,
			}
		},
		resetarVariaveis() {
			this.$refs.formAdicionarNotificacao.resetValidation()
			this.fornecedorSelecionado = null
			this.tipoInfracaoSelecionada = null
			this.orgaoSelecionado = null
			this.descricao = ''
		},
		montarObjCommon() {
			return {
				idEntidade: this.idEntidade,
				tipo: this.entidadeTipo,
			}
		},
	},
}
</script>

<style lang="stylus"></style>
